export const formatCurrency = (value) => {
  if (value == null || isNaN(value)) return '₹0';
  return new Intl.NumberFormat('en-IN', {
    style: 'currency',
    currency: 'INR',
    maximumFractionDigits: 0,
  }).format(value);
};

export const formatDate = (dateStr) => {
  if (!dateStr) return '—';
  const isoDate = String(dateStr).match(/^(\d{4})-(\d{2})-(\d{2})/);
  if (isoDate) return `${isoDate[3]}-${isoDate[2]}-${isoDate[1]}`;

  const d = new Date(dateStr);
  if (isNaN(d.getTime())) return dateStr;
  const day = String(d.getDate()).padStart(2, '0');
  const month = String(d.getMonth() + 1).padStart(2, '0');
  return `${day}-${month}-${d.getFullYear()}`;
};

export const formatDateTime = (dateStr) => {
  if (!dateStr) return '—';
  const value = String(dateStr);
  const time = value.match(/T(\d{2}:\d{2})/);
  return time ? `${formatDate(value)} ${time[1]}` : formatDate(value);
};

export const toApiDateTime = (dateStr) => {
  if (!dateStr) return undefined;
  const dateOnly = String(dateStr).match(/^(\d{4}-\d{2}-\d{2})$/);
  if (dateOnly) return `${dateOnly[1]}T00:00:00.000Z`;

  const date = new Date(dateStr);
  return Number.isNaN(date.getTime()) ? undefined : date.toISOString();
};